import { useState, cloneElement } from "react";
import {
	List,
	ListItem,
	ListItemText,
	Typography,
	ListItemIcon,
	Collapse,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import CategoryBudgetList from "./CategoryBudgetList";

export default function BudgetGroup({
	type,
	title,
	period,
	groupedBudgets,
	icon,
	color,
}) {
	const theme = useTheme();
	const [isExpanded, setIsExpanded] = useState(true);

	const userCurrency = localStorage.getItem("userCurrency");

	const sumTotalBudget = groupedBudgets.reduce(
		(sum, group) => sum + group.totalBudget,
		0,
	);

	const sumTransactions = groupedBudgets.reduce(
		(sum, group) => sum + group.totalGroupTransactionsSum,
		0,
	);
	const balanceStyles = {
		color: (
			type === "expense"
				? sumTransactions <= sumTotalBudget
				: sumTransactions >= sumTotalBudget
		)
			? theme.palette.values.positive
			: theme.palette.values.negative,
	};

	return (
		<>
			<List
				sx={{
					flexGrow: 1,
					backgroundColor: theme.palette.background.paper,
					borderRadius: "10px",
				}}
			>
				<ListItem sx={{ pt: 0, pb: 0 }}>
					<ListItemText>
						<Typography
							variant="h6"
							sx={{
								marginBottom: 0,
								display: "flex",
								gap: 0.5,
								alignItems: "center",
								fontWeight: "bold",
								color,
							}}
						>
							{icon &&
								cloneElement(icon, {
									sx: {
										fontSize: "1.7rem",
										color,
									},
								})}
							{title}
						</Typography>
					</ListItemText>
					<Typography
						variant="h6"
						sx={{
							marginBottom: 0,
							fontWeight: "bold",
							textAlign: "right",
							whiteSpace: "nowrap",
							...balanceStyles,
						}}
					>
						{Math.abs(sumTransactions).toFixed(2).toLocaleString()}{" "}
						{userCurrency}
					</Typography>
					<Typography
						variant="h6"
						sx={{
							marginBottom: 0,
							mx: 1,
							fontWeight: "bold",
							textAlign: "right",
							whiteSpace: "nowrap",
						}}
					>
						{"/"}
					</Typography>
					<Typography
						variant="h6"
						sx={{
							marginBottom: 0,
							fontWeight: "bold",
							textAlign: "right",
							whiteSpace: "nowrap",
						}}
					>
						{" "}
						{Math.abs(sumTotalBudget)
							.toFixed(2)
							.toLocaleString()}{" "}
						{userCurrency}
					</Typography>
					{groupedBudgets.length > 0 && (
						<ListItemIcon sx={{ minWidth: "auto", ml: 1 }}>
							{isExpanded ? (
								<ExpandLess
									sx={{ cursor: "pointer" }}
									onClick={() => setIsExpanded(!isExpanded)}
								/>
							) : (
								<ExpandMore
									sx={{ cursor: "pointer" }}
									onClick={() => setIsExpanded(!isExpanded)}
								/>
							)}
						</ListItemIcon>
					)}
				</ListItem>
				{groupedBudgets.length === 0 && (
					<Typography
						variant="body2"
						color="textSecondary"
						sx={{ pb: 1, pl: 2 }}
					>
						<Trans i18nKey="noCategoriesFound">
							No categories found for this group. You can add them
							in <Link to="/categories">category settings</Link>.
						</Trans>
					</Typography>
				)}
				<Collapse in={isExpanded}>
					{groupedBudgets.map((group) => (
						<CategoryBudgetList
							key={group.groupId}
							group={group}
							type={type}
							period={period}
						/>
					))}
				</Collapse>
			</List>
		</>
	);
}
